module.exports = __webpack_public_path__ + "static/img/icon_szh_cgal_yq_znzf@2x.63a722ca.png";